import React from 'react'
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <div>
      <footer className="bg-light text-dark pt-4 pb-2 mt-5 fade-up delay-2">
        <Container>
          <Row className="text-center text-md-start">

            {/* Column 1 */}
            <Col md={4} sm={6} className="mb-3">
              <h5 className="fw-bold text-danger">AKUL CREATIONS</h5>
              <p className="text-muted">
                Your one-stop destination for custom-stitched designs —
                blending tradition and modern fashion with perfection.
              </p>
            </Col>

            {/* Column 2 */}
            <Col md={5} sm={6} className="mb-3">
              <h6 className="fw-bold">Location</h6>

              <p className="text-muted mb-1">
                #222,12th Main,3rd Cross.Saraswathipuram,Mysore 570009</p>
              <p className="text-muted">📞 +91 8951088742 | 7899788742</p>
            </Col>

            {/* Column 3 */}
            <Col md={3} sm={6} className="mb-3">
              <h6 className="fw-bold">Follow Us</h6>
              <div>
                <a href="#" className="text-dark me-3 fs-4"><i className="bi bi-facebook"></i></a>
                <a href="#" className="text-dark me-3 fs-4"><i className="bi bi-instagram"></i></a>
                <a href="#" className="text-dark me-3 fs-4"><i className="bi bi-twitter"></i></a>
                <a href="#" className="text-dark fs-4"><i className="bi bi-youtube"></i></a>
              </div>
            </Col>
          </Row>

          <hr />

          <Row>
            <Col className="text-center">
              <p className="mb-0 text-muted">
                © {new Date().getFullYear()} AKUL CREATIONS STICKES AND DESIGNING
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  )
}
